import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

import excelExportService from "./excelExportService";

const initialState = {
  loading: false,
  error: null,
};

const downloadBlob = (response, fallbackFilename) => {
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const disposition = response.headers?.["content-disposition"];

  let filename = fallbackFilename;

  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);

    if (match?.[1]) {
      filename = match[1];
    }
  }

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

export const exportJongerenExcel = createAsyncThunk(
  "excelExport/exportJongerenExcel",
  async (schoolYearId, thunkAPI) => {
    try {
      const response =
        await excelExportService.exportJongerenExcel(schoolYearId);

      downloadBlob(response, "power-jongeren-export.xlsx");

      return true;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Excel export kon niet worden aangemaakt";

      return thunkAPI.rejectWithValue(message);
    }
  },
);

const excelExportSlice = createSlice({
  name: "excelExport",
  initialState,
  reducers: {
    clearExcelExportError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(exportJongerenExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(exportJongerenExcel.fulfilled, (state) => {
        state.loading = false;
        toast.success("Excel export succesvol gedownload");
      })
      .addCase(exportJongerenExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload);
      });
  },
});

export const { clearExcelExportError } = excelExportSlice.actions;

export default excelExportSlice.reducer;
